/* @flow */
import { GoogleMap, Marker, withGoogleMap } from 'react-google-maps';
import React from 'react';

type Props = {
  lat: number,
  lng: number,
  isMarkerShown: boolean,
  zoom?: number,
};

let zoom_level = 19;
const RegularMap = withGoogleMap(({ lat, lng, isMarkerShown = true, zoom = zoom_level, ...rest }: Props) => {
  let mapRef = React.createRef();
  const changeZoom = () => {
    if (mapRef.current !== null) {
      zoom_level = mapRef.current.getZoom();
    }
  };

  return (
    <GoogleMap
      {...rest}
      zoom={zoom}
      defaultMapTypeId="satellite"
      center={{ lat: parseFloat(lat), lng: parseFloat(lng) }}
      options={{
        streetViewControl: false,
        mapTypeControl: !!isMarkerShown,
        mapTypeControlOptions: {
          mapTypeIds: ['satellite', 'hybrid'],
        },
      }}
      ref={mapRef}
      onZoomChanged={changeZoom}
    >
      {isMarkerShown && <Marker position={{ lat: parseFloat(lat), lng: parseFloat(lng) }} />}
    </GoogleMap>
  );
});

export default RegularMap;
export { zoom_level };
